import LoLExaminationInstructions from './LoLExaminationInstructions';

export default LoLExaminationInstructions;
